import { createActions, handleActions } from 'redux-actions';

export const actionCreators = createActions({
    COUNTER: {
        INCREMENT: () => ({ amount: 1 }),
        DECREMENT: () => ({ amount: -1 })
    }
});

const reducer = handleActions({
    COUNTER: {
        INCREMENT: (state, action) => {
            console.log('########', action)
            return { value: state.value + action.payload.amount }
        },
        DECREMENT: (state, action) => {
            console.log('########', action)
            return { value: state.value + action.payload.amount }
        },
    }
},
    { value: 10 }
);

export default reducer
